module.exports = __webpack_public_path__ + "img/rsz_img_20211026_173621.e01e69e7.jpg";